import { render, staticRenderFns } from "./inflections-supp-table-wide.vue?vue&type=template&id=35320cb8&"
import script from "./inflections-supp-table-wide.vue?vue&type=script&lang=js&"
export * from "./inflections-supp-table-wide.vue?vue&type=script&lang=js&"
import style0 from "./inflections-supp-table-wide.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\uds\\projects\\alpheios\\components\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('35320cb8', component.options)
    } else {
      api.reload('35320cb8', component.options)
    }
    module.hot.accept("./inflections-supp-table-wide.vue?vue&type=template&id=35320cb8&", function () {
      api.rerender('35320cb8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "vue/components/inflections-supp-table-wide.vue"
export default component.exports